/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CandidateReviewSummaryDecision } from './candidateReviewSummaryDecision';
import type { CandidateReviewSummaryReason } from './candidateReviewSummaryReason';

export interface CandidateReviewSummary {
  id: string;
  profile_id: string;
  decision: CandidateReviewSummaryDecision;
  reason?: CandidateReviewSummaryReason;
  note?: string | null;
  reviewed_by_id?: string | null;
  reviewed_by_name?: string | null;
  reviewed_at: string;
  project_id: string;
  project_title?: string | null;
  search_id?: string | null;
  search_name?: string | null;
  in_this_search?: boolean;
}
